import CryptoJS from 'crypto-js'

const IV = '1234567890123412' // 16位
const KEY = '201707eggplant99' // 16位
/**
 * 加密
 */
// eslint-disable-next-line no-unused-vars
export function encrypt(str) {
  var key = CryptoJS.enc.Utf8.parse(KEY)// 秘钥
  var iv = CryptoJS.enc.Utf8.parse(IV) // 向量iv
  var encrypted = CryptoJS.AES.encrypt(str, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.toString()
}
/**
 * 解密
 * @param str
 */
// eslint-disable-next-line no-unused-vars
export function decrypt(str) {
  var key = CryptoJS.enc.Utf8.parse(KEY) // 秘钥
  var iv = CryptoJS.enc.Utf8.parse(IV) // 向量iv
  var decrypted = CryptoJS.AES.decrypt(str, key, { iv: iv, padding: CryptoJS.pad.Pkcs7 })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
